import { render } from "./EditPermission.vue?vue&type=template&id=4506af26"
import script from "./EditPermission.vue?vue&type=script&lang=js"
export * from "./EditPermission.vue?vue&type=script&lang=js"

import "./EditPermission.vue?vue&type=style&index=0&id=4506af26&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__